import { useUrlLocale } from '../i18n/url-locale';
import { getProductContent } from '../lib/content';
import { usePageTitle } from '../lib/use-page-title';
import { StatusBadge } from '../components/status-badge';

export function ProductPage() {
  const locale = useUrlLocale();
  const page = getProductContent(locale);
  usePageTitle('/product', page.meta.title);
  return (
    <div className="container page">
      <h1>{page.headline}</h1>
      <p className="lead">{page.intro}</p>
      <div className="product-sections">
        {page.sections.map((section) => (
          <section
            key={section.id}
            id={section.id}
            className={`card product-section${section.status === 'planned' ? ' card-planned' : ''}`}
            aria-labelledby={`${section.id}-title`}
          >
            <div className="section-heading">
              <h2 id={`${section.id}-title`}>{section.title}</h2>
              <StatusBadge status={section.status} />
            </div>
            <p>{section.body}</p>
            {section.points.length > 0 && (
              <ul>
                {section.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </div>
      <section className="narrow" aria-labelledby="product-closing">
        <h2 id="product-closing">{page.closing.title}</h2>
        <p>{page.closing.body}</p>
      </section>
    </div>
  );
}
